var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LayoutWithNavAndFooter',{attrs:{"renderFooter":false}},[_c('div',{attrs:{"id":"home"}},[_c('Landing'),_c('div',{staticClass:"v-line-bg"},[_c('WhyUs'),_c('ContactUs')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }